import type { Evento } from '@/types'
import { slugify } from './utils'

function formatDateForSlug(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date

  const year = d.getUTCFullYear()
  const month = String(d.getUTCMonth() + 1).padStart(2, '0')
  const day = String(d.getUTCDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function getEventoSlug(evento: Pick<Evento, 'titulo' | 'inicio_em'>): string {
  const base = slugify(evento.titulo)
  const date = formatDateForSlug(evento.inicio_em)
  return `${base}-${date}`
}
